<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>
                    <template v-if="!product.id">
                        <vue-headful :title="'Create Product - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Product] ' + product.product_name + ' - AMOS365'" />

                        <li class="breadcrumb-item">
                            <router-link :to="`/products/view/${product.id}`">{{ product.product_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ product.product_name }}</span>
                <span v-else>New Product</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_name, 'text-muted-no': !errors.product_name}">
                                    Product Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!product.product_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="product.product_name" :class="{'form-control': true, 'is-invalid': errors.product_name}" placeholder="Enter Product Name" />

                                    <div class="text-danger mt-1" v-if="errors.product_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.product_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.carrier_id, 'text-muted-no': !errors.carrier_id}">
                                    Product Type: <i class="fa fa-sm fa-asterisk text-danger" v-if="!product.product_type_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="product.product_type_id" :options="typeOptions" size="sm" :class="{'is-invalid': errors.product_type_id}" />

                                    <div class="text-danger mt-1" v-if="errors.product_type_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.product_type_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.carrier_id, 'text-muted-no': !errors.carrier_id}">
                                    Carrier: <i class="fa fa-sm fa-asterisk text-danger" v-if="!product.carrier_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-select v-model="product.carrier_id" :options="carrierOptions" size="sm" :class="{'is-invalid': errors.carrier_id}" />

                                    <div class="text-danger mt-1" v-if="errors.carrier_id">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.carrier_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_website, 'text-muted-no': !errors.product_website}">Website:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="product.product_website" :class="{'form-control': true, 'is-invalid': errors.product_website}" placeholder="Enter Website" />

                                    <div class="text-danger mt-2" v-if="errors.product_website">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.product_website">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="product.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_expires_at, 'text-muted-no': !errors.product_expires_at}">Product Expiration:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="product.product_expires_at" :class="{'form-control': true, 'is-invalid': errors.product_expires_at}" placeholder="Enter Expiration" />

                                    <div class="text-danger mt-2" v-if="errors.product_expires_at">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.product_expires_at">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_desc, 'text-muted-no': !errors.product_desc}">Description:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-textarea v-model="product.product_desc" size="sm" placeholder="Enter Product Description" />

                                    <div class="text-danger mt-2" v-if="errors.product_desc">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.product_desc">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="my-4">
                        <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveProduct()" :disabled="saving">
                            <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                            <template v-else><i class="fas fa-save"></i> Create</template>
                        </button>
                        <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveProduct()" :disabled="saving">
                            <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                            <template v-else><i class="fas fa-save"></i> Update</template>
                        </button>
                    </div>

                    <h5 class="mt-4">
                        <strong>Levels ({{ levels.length }}):</strong>
                        <button type="button" class="btn btn-sm btn-info" v-if="false" v-on:click="levels.push({product_level_name: null})"><i class="fa fa-plus-circle"></i> Level</button>
                    </h5>

                    <div class="card mb-3" v-for="(level, i) in levels">
                        <div class="card-header">
                            Product Level: {{ i + 1 }}
                            <button type="button" class="btn btn-sm btn-default" v-on:click="deleteLevel(level.id)" v-if="level.id" title="Delete Product Level"><i class="fa fa-trash text-danger"></i></button>
                            <button type="button" class="btn btn-sm btn-default" v-on:click="removeLevel(i)" v-else title="Remove New Product Level"><i class="fa fa-times text-danger"></i></button>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['levels.'+i+'.product_level_name'], 'text-muted-no': !errors['levels.'+i+'.product_level_name']}">
                                    Level Name: <i class="fa fa-asterisk text-danger fa-sm"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-input v-model="level.product_level_name" size="sm" placeholder="Enter Unique Level Name" :class="{'is-invalid': errors['levels.'+i+'.product_level_name']}" />

                                    <div class="text-danger mt-1" v-if="errors['levels.'+i+'.product_level_name']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['levels.'+i+'.product_level_name']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['levels.'+i+'.commission'], 'text-muted-no': !errors['levels.'+i+'.commission']}">
                                    Commission:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-input v-model="level.commission" size="sm" placeholder="Enter Level Commission" :class="{'is-invalid': errors['levels.'+i+'.commission']}" />

                                    <div class="text-danger mt-1" v-if="errors['levels.'+i+'.commission']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['levels.'+i+'.commission']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors['levels.'+i+'.description'], 'text-muted-no': !errors['levels.'+i+'.description']}">
                                    Description:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-textarea v-model="level.description" size="sm" placeholder="Enter Level Description" :class="{'is-invalid': errors['levels.'+i+'.description']}" />

                                    <div class="text-danger mt-1" v-if="errors['levels.'+i+'.description']">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors['levels.'+i+'.description']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cursor-hover" style="border: 1px dashed #ccc; padding: 3px 5px; text-align: center; font-size: 12px; background: #ffffff;" v-on:click="levels.push({product_level_name: null})">
                        <i class="fa fa-plus-circle text-success"></i> Add Product Level
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <hr/>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveProduct()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveProduct()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                product: {},
                errors: {},
                types: [],
                carriers: [],
                levels: [],
            }
        },

        computed: {
            typeOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Product Type --'}];

                //Main Loop
                for(var i = 0; i < this.types.length; i++)
                {
                    options.push({value: this.types[i].id, text: this.types[i].product_type_name});
                }

                //Send it
                return options;
            },

            carrierOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Carrier --'}];

                //Main Loop
                for(var i = 0; i < this.carriers.length; i++)
                {
                    options.push({value: this.carriers[i].id, text: this.carriers[i].carrier_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getProduct(){
                //Send it
                this.$http.get('/products/edit' + (this.id ? '/'+this.id : ''), this.$route.query)
                    .then(response => {
                        //Set the product
                        this.product = response.data.product;
                        this.carriers = response.data.carriers;
                        this.types = response.data.types;

                        //Set the levels
                        if(this.product.levels)
                        {
                            //Set the levels
                            this.levels = this.product.levels;
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveProduct(){
                //Helpers
                this.saving = true;

                //SEt the levels
                this.product.levels = this.levels;

                //Send it
                this.$http
                .post('products/save', this.product)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Product ' + (this.product.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/products/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Product');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            deleteLevel(level_id){
                //Confirm?
                if(!confirm('Are you sure you want to delete this level?'))
                {
                    return;
                }

                //Do what?
            },

            removeLevel(i){
                //Confirm?
                if(!confirm('Are you sure you want to remove this new level?'))
                {
                    return;
                }

                //Do what?
                this.levels.splice(i, 1);
            },

        },

        mounted() {
            //Get the Product
            this.getProduct();
        }
    }
</script>
